import { render, staticRenderFns } from "./AddSupplierDialog.vue?vue&type=template&id=6f967f64"
import script from "./AddSupplierDialog.vue?vue&type=script&lang=js"
export * from "./AddSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports